export const serviceToServiceScope = 'serviceToService:*'
